module.exports = __webpack_public_path__ + "static/media/thumb_jsListaCompras.2a63f20e.jpg";